import dayjs from 'dayjs'

export const getCountdown = (type: string, until?: string, date?: string, finishedAt?: string) => {
    const mainDate = date && type !== 'window' ? date : until

    const countdownNum = dayjs(!finishedAt ? mainDate?.slice(0, -2) + '00' : mainDate).diff(
        !finishedAt ? dayjs() : finishedAt,
        'm'
    )

    const isLate = countdownNum < 0

    let countdown

    if (countdownNum > 120 || countdownNum < -120) {
        countdown = `${Math.ceil(countdownNum / 60)} h`
    } else {
        countdown = `${countdownNum} m`
    }

    return [countdown, isLate] as [string, boolean]
}
